/**
 * Share Button - Social action for sharing content
 *
 * Outlined circular button with paper plane icon for sharing functionality.
 * Can be used in headers, cards, photo galleries, or any context where
 * sharing content is appropriate.
 */

import { Button } from '../../../ui/Button';
import { PaperPlaneIcon } from '../../../ui/icons';

/**
 * Props for social action buttons
 */
export type SocialActionButtonProps = {
  onClick: () => void;
  'aria-label': string;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

/**
 * Share Button Component
 *
 * @example
 * <ShareButton
 *   onClick={() => shareContent(listing)}
 *   aria-label="Share this listing"
 * />
 */
export const ShareButton = ({
  onClick,
  'aria-label': ariaLabel,
  disabled = false,
  size = 'md',
}: SocialActionButtonProps) => (
  <Button
    shape="circle"
    tone="neutral"
    emphasis="outlined"
    size={size}
    onClick={onClick}
    aria-label={ariaLabel}
    title={ariaLabel}
    disabled={disabled}
  >
    <PaperPlaneIcon />
  </Button>
);
